import React from 'react'
import './HomeScreen.css'

function Marquee({text}) {
    return (
        <div className='marquee-container'>
            <p className='marquee-text'>
                {text}
            </p>
        </div>
    )
}

export default Marquee